import { Component, Input, OnInit } from "@angular/core";
import {
  NgbModal,
  NgbActiveModal,
  NgbDateStruct,
  NgbCalendar,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { ChangerEtape } from "src/app/core/services/business/model/changer-etape";

@Component({
  selector: "app-changer-etape",
  templateUrl: "./changer-etape.component.html",
  styleUrls: ["./changer-etape.component.scss"],
})
export class ChangerEtapeComponent implements OnInit {
  errorMessage: String = null;
  form2: FormGroup;
  pressButton: Boolean = false;

  changeStateDTO: ChangerEtape = new ChangerEtape();

  @Input() currentTaskId;

  constructor(
    private _router: Router,
    private _requestService: RequestService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      currentTaskId: [null, Validators.compose([Validators.required])],
      cancelActivityId: [null, Validators.compose([Validators.required])],
      startActivityId: [null, Validators.compose([Validators.required])],
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.changeStateDTO.currentTaskId = this.currentTaskId;
  }

  change(): void {
    this.spinner.show();
    this._requestService
      .changerEtape(this.changeStateDTO)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
